"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("./Header/base"));
var basketball_1 = tslib_1.__importDefault(require("./Header/basketball"));
var football_1 = tslib_1.__importDefault(require("./Header/football"));
var handball_1 = tslib_1.__importDefault(require("./Header/handball"));
var hockey_1 = tslib_1.__importDefault(require("./Header/hockey"));
var tennis_1 = tslib_1.__importDefault(require("./Header/tennis"));
var volleyball_1 = tslib_1.__importDefault(require("./Header/volleyball"));
var hockeyball_1 = tslib_1.__importDefault(require("./Header/hockeyball"));
var react_1 = tslib_1.__importDefault(require("react"));
var SportHeader = function (_a) {
    var transformedData = _a.transformedData;
    switch (transformedData === null || transformedData === void 0 ? void 0 : transformedData.sport) {
        case 'futsal':
        case 'football':
            return react_1["default"].createElement(football_1["default"], tslib_1.__assign({}, transformedData));
        case 'hockey':
        case 'floorball':
            return react_1["default"].createElement(hockey_1["default"], tslib_1.__assign({}, transformedData));
        case 'tennis':
            return react_1["default"].createElement(tennis_1["default"], tslib_1.__assign({}, transformedData));
        case 'volleyball':
            return react_1["default"].createElement(volleyball_1["default"], tslib_1.__assign({}, transformedData));
        case 'basketball':
            return react_1["default"].createElement(basketball_1["default"], tslib_1.__assign({}, transformedData));
        case 'handball':
            return react_1["default"].createElement(handball_1["default"], tslib_1.__assign({}, transformedData));
        case 'hockeyball':
            return react_1["default"].createElement(hockeyball_1["default"], tslib_1.__assign({}, transformedData));
        default:
            return react_1["default"].createElement(base_1["default"], tslib_1.__assign({}, transformedData));
    }
};
exports["default"] = SportHeader;
